import axios from "axios";
import { url } from 'utils/urls';


export const updateUserInfo = (data, formName, id) => {
    const headers = { "Content-Type": "application/json" };
    return axios.put(`${url.ppa.users}/${id}`, data, { headers, withCredentials: true})
};

// Password Change Call Simulation
// TBD
export const asyncChangePassword = (data) => (new Promise((resolve, reject) => {
    setTimeout(()=>{
        Math.floor(100 * Math.random()) < 51 ? resolve({ data }) : reject("NETWORK ERROR")
    }, 1000)
}));
